export interface IMotivoMovimientoBeca {
  id?: string | null;
  clave?: string | null;
  descripcion?: string | null;
  tipoMovimientoBecaId?: string | null;
  activo?: boolean | null;
}

export class MotivoMovimientoBeca implements IMotivoMovimientoBeca {
  constructor(
    public id?: string | null,
    public clave?: string | null,
    public descripcion?: string | null,
    public tipoMovimientoBecaId?: string | null,
    public activo?: boolean | null
  ) {}

  static fromObject(data: IMotivoMovimientoBeca): MotivoMovimientoBeca {
    const motivoMovimientoBeca = new MotivoMovimientoBeca();
    for (const [key, value] of Object.entries(data)) {
      motivoMovimientoBeca[key] = value;
    }
    return motivoMovimientoBeca;
  }
}
